export const userLanguage = () => {
  const lang = window.navigator.language || window.navigator.userLanguage;
  const defaultLang = lang.toLowerCase();
  if (defaultLang === "zh-cn") {
    return "zh_chs";
  } else if (defaultLang === "zh-tw") {
    return "tw";
  } else if (defaultLang === "vi") {
    return "vi";
  } else {
    return "en";
  }
};
